import type { IVirtualizedTreeNodeModel } from "@voltalis/ui-kit/components";

import { walkTreeByLevel } from "@voltalis/frontend-utils";
import { sum } from "es-toolkit";

import { TSiteSectionsTreeData } from "@/app/tools/new-section-management/site-sections-tree/site-sections-tree.types";

type TSiteSectionTreeNode = IVirtualizedTreeNodeModel<TSiteSectionsTreeData>;

function hasSiteSectionData(
  node: TSiteSectionTreeNode,
): node is TSiteSectionTreeNode & { data: NonNullable<TSiteSectionsTreeData> } {
  return node.data != null;
}

function getApplianceCountTotal(section: TSiteSectionsTreeData): number {
  if (!section) return 0;

  return sum(Object.values(section.applianceCountByCategory));
}

function isDescendantOfMovedNode(draggedNode: TSiteSectionTreeNode, targetNode: TSiteSectionTreeNode): boolean {
  if (!targetNode.data) return false;

  for (const current of walkTreeByLevel(draggedNode.children)) {
    if (current.data?.id === targetNode.data.id) return true;
  }

  return false;
}

function isCurrentParent(draggedNode: TSiteSectionTreeNode, targetNode: TSiteSectionTreeNode): boolean {
  const currentParentId = draggedNode.data?.parent?.id ?? null;
  const targetParentId = targetNode.data?.id ?? null;

  return currentParentId === targetParentId;
}

export function canDropSiteSectionNode(draggedNode: TSiteSectionTreeNode, targetNode: TSiteSectionTreeNode): boolean {
  if (!hasSiteSectionData(draggedNode)) return false;

  if (draggedNode.data.id === targetNode.data?.id) return false;
  if (isDescendantOfMovedNode(draggedNode, targetNode)) return false;
  if (isCurrentParent(draggedNode, targetNode)) return false;

  return getApplianceCountTotal(targetNode.data) === 0;
}
